import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_provider/${agro_exporter_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },

  fetchProvider(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_provider/${agro_exporter_id}/fetch_provider/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchSummary(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_provider/${agro_exporter_id}/fetch_summary/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchDiscardedMotives(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_provider/${agro_exporter_id}/fetch_discarded_motives/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchHarvestsMonthly(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_provider/${agro_exporter_id}/fetch_harvests_monthly/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchHarvestsWeekly(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_provider/${agro_exporter_id}/fetch_harvests_weekly/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchTotalsMonthly(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_provider/${agro_exporter_id}/fetch_totals_monthly/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchTotalsWeekly(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_provider/${agro_exporter_id}/fetch_totals_weekly/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchCropSizePackagesByWeeks(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_provider/${agro_exporter_id}/fetch_crop_size_packages_by_weeks/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchCropSizes(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_provider/${agro_exporter_id}/fetch_crop_sizes/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchCropSizePackages(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_provider/${agro_exporter_id}/fetch_crop_size_packages/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchExportedBatchesTotal(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_provider/${agro_exporter_id}/fetch_exported_batches_total/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchExportedBatches(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id,
    current_page,
    rows_per_page
  ) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_provider/${agro_exporter_id}/fetch_exported_batches/${agro_exporter_process_id}/${provider_type}/${provider_id}/${current_page}/${rows_per_page}`
    );
  },

  fetchHarvestedBatch(
    agro_exporter_id,
    agro_exporter_process_id,
    harvested_batch_id
  ) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_provider/${agro_exporter_id}/fetch_harvested_batch/${agro_exporter_process_id}/${harvested_batch_id}`
    );
  }
};
